(function (angular) {
    angular.module('bizPartEngage').controller('modules.journey', journeyController);

    journeyController.$inject = [];

    function journeyController() {
        var vm = this;
        vm.IsJourneyLocked = IsPortalSettingTrue('IsJourneyLocked');
    }
})(window.angular);
